<template>
  <div
    class="row row-item-transparent-with-border pt-3 pb-3"
    @click="click">
    <div
      :class="{ 'col-5': alreadySent, 'col-6': !alreadySent }"
      class="text-left">
      <h4
        class="mb-0"
        style="font-weight:bold">{{ companyName }}</h4>
      <h4 class="mb-0">{{ activityArea }}</h4>
    </div>
    <div
      :class="{ 'col-5 pr-0': alreadySent, 'col-6': !alreadySent }"
      class="text-right">
      <div class="d-inline-block align-middle">
        <h4
          class="mb-0"
          style="font-weight:bold">{{ time }}</h4>
        <h4 class="mb-0">{{ getDayFromDate() }}</h4>
      </div>
    </div>
    <div
      v-if="alreadySent"
      class="col-2 envelope-container">
      <i class="fas fa-envelope envelope"/>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'SummaryTimeEntry',
  components: {},
  props: {
    companyName: {
      type: String,
      default: '',
    },
    activityArea: {
      type: String,
      default: '',
    },
    time: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: null,
    },
    alreadySent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  methods: {
    getDayFromDate() {
      return moment(this.date).format('dddd D MMM YYYY');
    },
    click() {
      this.$router.push(`/dashboard/time-entries/${this.id}`);
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.row-item-transparent-with-border {
    padding: $top-menu-height 0;
    cursor: pointer;
  }
}
.envelope-container {
  display: flex;
  align-items: center;
}
.envelope {
  margin: auto;
}
</style>
